<template>
  <div v-if="currentReserve == null">Loading</div>
  <div v-else class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div class="card-header pb-0 d-flex justify-content-between">
            <div>
              <h3 class="card-title text-primary mb-0">Editar reserva</h3>
              <div class="sub-line"></div>
            </div>
          </div>
          <div class="card-body">
            <div class="col-sm mx-60">
                <reserve-form :entity="currentReserve" action="update" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted} from "vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import ReserveForm from "./ReserveForm.vue";


    const store = useStore();
    const route = useRoute();


    const getCurrentReserve = async (id) => {
      return await store.dispatch("reserve/getReserveById", id);
    };

    const currentReserve = computed(() => {
      if(! store.state.reserve.currentReserve) return null
      let trail =  store.state.reserve.currentReserve
      if( trail.trail && trail.trail['@id']){
        trail.trail = trail.trail['@id']
      }
      if( trail.user && trail.user['@id']){
        trail.user = trail.user['@id']
      }

      return trail

    });

    onMounted(() => {
      getCurrentReserve(route.params.id)
    });



</script>
